import React from "react";
import "./PartnerMarquee.css";

/* Sector wordmark strip — until verified partner logos are supplied, this strip
   leans on the truth we can already tell: the industries we place into.
   Each wordmark is a category, not a brand. Replace with real logos when
   provided and remove the SECTORS array. */
const SECTORS = [
  { name: "Construction", note: "Sector" },
  { name: "Hospitality", note: "Sector" },
  { name: "Oil & Gas", note: "Sector" },
  { name: "Healthcare", note: "Sector" },
  { name: "Logistics", note: "Sector" },
  { name: "Manufacturing", note: "Sector" },
  { name: "Facilities Mgmt", note: "Sector" },
  { name: "Security", note: "Sector" },
];

export default function PartnerMarquee() {
  return (
    <section className="marquee" aria-label="Sectors we place into">
      <div className="container">
        <div className="marquee__intro">
          <span className="eyebrow">Where we place</span>
          <p className="marquee__lead">
            Eight sectors across the Gulf. Built around what each industry
            actually needs — not a one-size pipeline.
          </p>
        </div>
      </div>

      <div className="marquee__track" aria-hidden="true">
        <div className="marquee__row">
          {[...SECTORS, ...SECTORS].map((s, i) => (
            <div className="marquee__slot" key={i}>
              <span className="marquee__slot-label">{s.name}</span>
              <span className="marquee__slot-tag">{s.note}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
